import { Platforms, PlatformsBackend, PlatformsBackendNames } from '@core/models';
import { pipe } from 'fp-ts/function';
import { contramap } from 'fp-ts/Ord';
import { boolean } from 'fp-ts';

export function toPlatformsBackendName(platform: Platforms) {
  return PlatformsBackend[platform] as PlatformsBackendNames;
}

export function toPlatformName(platform: PlatformsBackendNames) {
  return Platforms[platform] as Platforms;
}

export const disabledLast = pipe(
  boolean.Ord,
  contramap((it: { disabled?: boolean }) => !!it.disabled)
);
